/**
 * @generated SignedSource<<527ee5b111d09ccada5501d6c9a653f5>>
 * @relayHash 629a26ef1b288fa22c292d07a19b9ccb
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/410.0.0-2023-04-20T13:25:25.279Z/sendMessageMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContactDealerInput = {
  action?: string | null;
  buyerId: string;
  captchaToken?: string | null;
  clientMutationId?: string | null;
  currencyConversionRateEventId?: string | null;
  displayName?: string | null;
  isOptIn?: boolean | null;
  itemPk?: string | null;
  messageContent: string;
  pageContext?: string | null;
  sellerPk: string;
};
export type sendMessageMutation$variables = {
  input: ContactDealerInput;
};
export type sendMessageMutation$data = {
  readonly contactDealer: {
    readonly conversation: {
      readonly id: string;
    } | null;
  } | null;
};
export type sendMessageMutation = {
  response: sendMessageMutation$data;
  variables: sendMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ContactDealerPayload",
    "kind": "LinkedField",
    "name": "contactDealer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/410.0.0-2023-04-20T13:25:25.279Z/sendMessageMutation",
    "metadata": {},
    "name": "sendMessageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "220832c976b0ad6213d8e667ff2ff6ff";

export default node;
